// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1c3ga","title":"AfterBackImages_title__3YVZM","images":"AfterBackImages_images__KLREz"};